import { CronExpressionParser } from 'cron-parser';

const getNextCronDate = (cronExpression: string, baseDate: Date = new Date()): string => {
  try {
    const interval = CronExpressionParser.parse(cronExpression, { currentDate: baseDate });
    const nextDate = interval.next().toString();
    return nextDate;
  } catch (error: unknown) {
    return '';
  }
};

/**
 * Formats file type for display: SALES_ORDERS -> Sales orders
 */
const formatFileType = (value: string): string => {
  if (!value) return '';
  let result = value.replace(/_/g, ' ');
  result = result.toLowerCase();
  return result.charAt(0).toUpperCase() + result.slice(1);
};

/**
 * Formats connector type for display: TARGET -> Target
 */
const formatConnectorType = (value: string): string => {
  if (!value) return '';
  const result = value.toLowerCase();
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export { formatConnectorType, formatFileType, getNextCronDate };
